import type { ExcludedProductsType, ProductSelectionType } from '../AppsTwitch.types'

export const isExcludedProductSelection = (
  productSelection: ProductSelectionType,
): productSelection is Extract<ProductSelectionType, ExcludedProductsType> =>
  productSelection.type === 'EXCLUDED_PRODUCTS'
